const NIVEL_RISCO = {
  INEXPRESSIVO: 'INEXPRESSIVO',
  BAIXO: 'BAIXO',
  MODERADO: 'MODERADO',
  ELEVADO: 'ELEVADO',
  CRITICO: 'CRITICO',
  NAO_UTILIZADA: 'NAO_UTILIZADA',
};

export default NIVEL_RISCO;
